import type { UiTheme } from "../theme";

// The ONE box literal of the logger/summary card family: surface fill,
// hairline border, r3 corner, s4 padding, s3 inner rhythm. It was written by
// hand three times — WorkoutTotalsCard, WorkoutHeatMap, and (as of DS-18) the
// boxed CaloriesEffortBlock — with identical token values in all three, which
// is the moment §CONSOLIDAMENTO says to build the primitive instead of adding
// the copy.
//
// Sibling of makeHomeBoxStyle (Home/glanceCardStyles.ts), which does the same
// job for the Home surface with its own gutter/margin rhythm. Both are
// deliberately style helpers rather than the full <Card> component: that
// primitive lands with CN-3, and when it does it collapses these two.
export function makeCardBoxStyle(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r } = theme;
  return {
    backgroundColor: p.surface,
    borderColor: p.border,
    borderWidth: 1,
    borderRadius: r.r3,
    padding: s.s4,
    gap: s.s3,
  } as const;
}
